import React, { useEffect } from "react";
import Banner from "../../Alumni/Partials/Banner";

import "./Hostel.css";

const HostelDemo = () => {
  const facilities = [
    {
      icon: "fa fa-adjust",
      title: "Air-conditioned & Non-AC Rooms",
      description:
        "Comfortable single and shared room options with basic furnishing",
    },
    {
      icon: "fa fa-wifi",
      title: "High-speed Wi-Fi",
      description:
        "Seamless internet connectivity throughout the hostel premises",
    },
    {
      icon: "fa fa-cutlery",
      title: "Hygienic Dining",
      description:
        "Clean, spacious dining halls serving nutritious and balanced meals",
    },
    {
      icon: "fa fa-shield",
      title: "24/7 Security",
      description:
        "Round-the-clock security with access control and surveillance",
    },
  ];

  const hostelImages = [
    { src: "/assets/images/hostel.webp", alt: "Hostel Room" },
    { src: "/assets/images/hostel1.webp", alt: "Dining Hall" },
    { src: "/assets/images/hostel.webp", alt: "Hostel Common Area" },
    { src: "/assets/images/hostel1.webp", alt: "Hostel Exterior" },
  ];

  return (
    <>
      <Banner />
      <section className="hostel-section">
        <div className="container">
          <div class="sec-title text-center">
            <h2>Hostel @ CARE</h2>
          </div>

          {/* Content and Video Row */}
          <div className="row mb-5">
            {/* Left Column - Content */}
            <div className="col-lg-6 hostel-content">
              <p>
                The Hostel at CARE has Air-conditioned and Non-AC single and
                shared room options and is equipped with basic furnishing and
                provided uninterrupted water and power supply. Gymnasium, sport
                amenities, laundromat and Wi-Fi service are the other facilities
                available for the students. Living on campus always provides the
                students an opportunity for transition and a connection with a
                diverse population and thereby helping in improving
                interpersonal skills.
              </p>
              <p>
                Students' security is our top priority at CARE. With all the
                entry and exit points of the hostel premises being guarded by
                access control turnstiles, the security of students has been
                ensured completely thereby enabling the families of the students
                to be in peace without any worry. Safety and security have
                always been ensured in spirit by wardens, supervisors,
                maintenance staff and security guards.
              </p>
              <p>
                Clean, spacious and well-ventilated dining halls in the hostels
                serve hygienic, wholesome and nutritious food. A balanced menu
                is prepared from time to time with the consultation of student
                representatives and administrators. Review meetings are
                conducted periodically to address issues and also to update
                about any latest changes in services. Every effort goes into
                providing a safe, secure and comfortable living for all the
                students in the hostels. The aim is to make it a home away from
                home.
              </p>
            </div>

            {/* Right Column - Video */}
            <div className="col-lg-6">
              <div
                className="video-container-hostel"
                style={{
                  position: "relative",
                  paddingBottom: "56.25%",
                  height: 0,
                  overflow: "hidden",
                  maxWidth: "100%",
                  backgroundColor: "#000",
                  borderRadius: "10px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                }}
              >
                <iframe
                  src="https://www.youtube.com/embed/7aFZ467NWWs"
                  title="Hostel Tour"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: "0",
                    borderRadius: "10px",
                  }}
                ></iframe>
              </div>
            </div>
          </div>

          {/* Facilities Cards Section */}
          <div className="row">
            <div className="col-12">
              <div class="sec-title text-center">
                <h2>Our Hostel Facilities</h2>
              </div>

              <div className="row d-flex justify-content-center align-items-center">
                {facilities.map((facility, index) => (
                  <div className="col-lg-3 col-md-6 mb-4 col-12" key={index}>
                    <div className="facility-hostel">
                      <div className="facility-hostel-icon">
                        <i className={facility.icon}></i>
                      </div>
                      <h5>{facility.title}</h5>
                      <p>{facility.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Image Gallery Swiper Section */}
          <div className="row">
            <div className="col-12">
              <div class="sec-title text-center">
                <h2>Hostel Gallery</h2>
              </div>

              <div className="hostel-gallery">
                <div className="gallery-swiper">
                  {hostelImages.map((img, index) => (
                    <div className="gallery-slide" key={index}>
                      <img
                        src={img.src}
                        alt={img.alt}
                        className="gallery-image"
                      />
                      <div className="image-overlay">
                        <span>{img.alt}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HostelDemo;
